const PALETTE_SIZE = 6;

/** Deterministic hash so the same person always gets the same avatar colour. */
function hashString(value: string): number {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = (hash * 31 + value.charCodeAt(i)) >>> 0;
  }
  return hash;
}

/** Returns a stable index 1–6 into the `--avatar-N-*` token pairs. */
export function avatarPaletteIndex(name: string): number {
  return (hashString(name) % PALETTE_SIZE) + 1;
}

/** Initials for an avatar: first letter of up to two words. */
export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}
